import api from "../utils/api";
import { isBizNull, MathUtils } from "../utils";
import { S_LANG, webStorage } from "../utils/webStorage";
import { orderTypes } from "../utils/lynkco-constants";
import storeApi from "../utils/storeApi";

export const getGearsProgressBars = async (progressBars, selectedBar) => {
  if (progressBars) {
    const barProps = {
      steps: []
    };
    let stepsArr = progressBars?.fields.steps || [];
    let barCurrentIndex = 0;
    stepsArr.forEach((item, index) => {
      if (selectedBar?.fields.label.value === item.fields.label.value) {
        barCurrentIndex = index;
      }
    });
    barProps.steps = stepsArr.map((item, index) => {
      let bool = selectedBar?.fields.label.value === item.fields.label.value;
      let active = selectedBar?.fields.label.value === item.fields.label.value;
      if (index < barCurrentIndex && barCurrentIndex !== progressBars?.fields.steps.length - 1) {
        bool = true;
      }
      let stepsItem = {
        label: item.fields.label.value,
        callback: () => console.log("Step clicked"),
        done: bool,
        route: item.fields.route.value,
        active: active,
        disabled: active ? active : !bool
      };
      return stepsItem;
    });
    return barProps;
  } else {
    return false;
  }
};
export const getGearsOrderSummary = async (totalAmount, body, summaryItem, inStore = false) => {
  const lang = webStorage.get(S_LANG);
  const { obj: promotions } = await api.user.promotion(null, {
    skuIds: body.skuQtyVoList.map(e => e.skuId)
  });
  body.subType = orderTypes.gear;
  if (promotions) {
    body.promotions = promotions.map(x => ({
      promotionId: x.promotionId,
      promotionType: x.promotionType
    }));
  }

  try {
    const res = await (inStore ? storeApi.order.preview(null, body) : api.order.preview(null, body));
    if (res) {
      const hasData = !isBizNull(res.obj);
      const { orderItems, grandTotal, shipping, totalPrice } = res.obj;
      let shoppingItem = hasData
        ? orderItems.map(item => {
            return {
              name: item.spuName,
              quantity: item.qty
            };
          })
        : [];
      let orderSummary = {
        items: shoppingItem,
        payment: {
          price: totalPrice,
          shipping: shipping
        },
        total: totalPrice
      };
      const { headingTitle, headingBody, itemHeading, paymentHeading, priceTitle, shippingTitle, totalTitle } = summaryItem?.fields || {};
      const result = {
        heading: {
          title: headingTitle.value,
          body: headingBody.value
        },
        itemList: {
          heading: itemHeading.value,
          items: shoppingItem
        },
        payment: {
          heading: paymentHeading.value,
          price: {
            title: priceTitle.value,
            value: MathUtils.priceFormat(orderSummary.payment.price, lang)
          },
          shipping: {
            title: shippingTitle.value,
            value: MathUtils.priceFormat(orderSummary.payment.shipping, lang)
          }
        },
        total: {
          title: totalTitle.value,
          value: MathUtils.priceFormat(grandTotal, lang)
        },
        disclaimer: summaryItem?.fields.disclaimer.value
      };
      return [res.obj, result];
    }
  } catch (err) {
    return null;
  }
};
